import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useCheckout } from '../../useCheckout';
import { computed, onUnmounted } from 'vue';
import BasketDeliverableItemsSelection from '@/b2c/basket/ui/BasketDeliverableItemsSelection.vue';
import { useDeliverableLineItems } from '@/b2c/checkout/useDeliverableLineItems';
import siteContextStore from '@/shared/content/site-context.store';
import { useRouter } from 'vue-router';
import { DeliverableSelectItem } from '@/b2c/basket/useDeliverables';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentItemsOutOfStock',
  setup(__props) {

const labels = useBlockLabels();
const { itemIdsOutOfStock, clearItemIdsOutOfStock } = useCheckout();
const { deliverableLineItems } = useDeliverableLineItems();
const { replace: goto } = useRouter();

onUnmounted(clearItemIdsOutOfStock);

const items = computed<DeliverableSelectItem[]>(() => {
    return deliverableLineItems(itemIdsOutOfStock.value) as DeliverableSelectItem[];
});

const clearAndGoToBasket = (): void => {
    setTimeout(() => goto(siteContextStore.settings.basketPageUrl), 300);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BasketDeliverableItemsSelection, {
      items: _unref(items),
      "read-only": true,
      class: "mx-auto max-w-500 flex flex-col justify-center"
    }, null, 8, ["items"]),
    _createElementVNode("button", {
      type: "button",
      class: "c-button c-button--primary flex flex-nowrap items-center mx-auto mt-x6",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (clearAndGoToBasket()))
    }, _toDisplayString(_unref(labels).paymentItemsOutOfStockButton), 1)
  ]))
}
}

})